import {faExclamationCircle} from '@fortawesome/pro-solid-svg-icons';
import clsx from 'clsx';
import styled from 'styled-components';

import {Icon} from '../../components/Icon/Icon';

type Props = {
  className?: string;
  children?: React.ReactNode;
};
export function FormError({children, className}: Props): React.JSX.Element {
  return (
    <StyledFormError className={clsx(className, 'text-tomato11')}>
      <Icon icon={faExclamationCircle} className="text-tomato11" /> {children}
    </StyledFormError>
  );
}
const StyledFormError = styled.p`
  font-size: 0.8em;
  font-weight: 700;
  margin: 0.5rem 0 0;
  display: block;
`;
